import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import BlazeForm from 'blaze-form';
import LoadingPage from '../LoadingPage';
import ApiService from '../../services/ApiService';
import history from '../../history';
import toastr from '../toastr';

const ConfigPage = ({ match }) => {
  const { name } = match.params;
  const [layout, setLayout] = useState(null);

  if (!name) {
    history.push('/UCG0');
  }

  useEffect(() => {
    ApiService.get(`config/${name}/layout`).then(({ data }) => {
      setLayout(data.layout);
    });
  }, [name]);

  if (!name) {
    return null;
  }

  const handleSubmit = data => {
    ApiService.post('config', data).then(() => {
      toastr.success('Config Updated');
    });
  };

  if (!layout) {
    return <LoadingPage />;
  }

  return (
    <BlazeForm showHelp layout={layout} onSubmit={handleSubmit} useTypedData />
  );
};

ConfigPage.propTypes = {
  match: PropTypes.any,
};

export default ConfigPage;
